var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.title && _vm.title.length)?_c('p',{staticClass:"text-caption mb-2",class:{
    'text-center': _vm.center
  }},[_vm._v(_vm._s(_vm.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }